/**
 * All page copy lives here so it can be edited without touching components.
 * Inline markup: **bold** and *italic* (see components/ui/RichText.jsx).
 */

export const site = {
  brand: 'LNG School',
  program: 'LNG Ready',
  checkoutUrl: 'https://checkout.lngschool.com/b/00wcMY57Y25oa0W93v7Vm03',
  supportEmail: 'support@lngschool.com',
  cohortStart: '4 August 2026',
  cohortStartShort: 'Starting August 4th, 2026',
};

export const testimonials = [
  {
    slug: 'michael-schach',
    name: 'Michael Schach',
    role: 'CEO & Co-Founder',
    company: 'Calypso Commodities',
    photo: '/testimonials/michael-schach.jpg',
    quote:
      "Captain Mustapha's greatest strength is connecting the technical realities of LNG shipping with the commercial side of the industry. He offers a unique perspective, and I highly recommend learning from him.",
  },
  {
    slug: 'mehdy-touil',
    name: 'Mehdy Touil',
    role: 'LNG Lead Specialist & Shareholder',
    company: '',
    photo: '/testimonials/mehdy-touil.jpg',
    quote:
      'Most trainers provide generic knowledge, but Captain Mustapha goes much deeper. His operational and commercial LNG experience gives you the complete learning experience.',
  },
  {
    slug: 'adnan-ezzarhouni',
    name: 'Adnan Ezzarhouni',
    role: 'General Manager',
    company: 'GTT China',
    photo: '/testimonials/adnan-ezzarhouni.jpg',
    quote:
      'Captain Mustapha explains LNG in a simple way while connecting theory with real-world practice. His extensive experience and practical examples make complex topics easy to understand.',
  },
  {
    slug: 'eugen-tereschenko',
    name: 'Eugen Tereschenko',
    role: 'Co-Founder',
    company: 'Calypso Commodities',
    photo: '/testimonials/eugen-tereschenko.jpg',
    quote:
      'Captain Mustapha not only knows LNG in theory, but has lived it as a ship captain. He connects theory with practice, making him someone you can truly learn from.',
  },
  {
    slug: 'joshua-magness',
    name: 'Joshua Magness',
    role: 'Business Development Manager',
    company: 'Gato Negro LNG',
    photo: '/testimonials/joshua-magness.jpg',
    quote:
      "Captain Mustapha's experience as an LNG Master Mariner is incredibly valuable. His understanding of LNG operations helps you understand how the LNG business as a whole works.",
  },
  {
    slug: 'daniel-mann',
    name: 'Daniel Mann',
    role: 'Chief Commercial Officer',
    company: 'bound4blue',
    photo: '/testimonials/daniel-mann.jpg',
    quote:
      'Captain Mustapha has a deep understanding of LNG shipping and brings a very practical approach. He explains complex topics clearly without overcomplicating them.',
  },
  {
    slug: 'jean-christian-heintz',
    name: 'Jean-Christian Heintz',
    role: 'Global LNG Consultant & Trader',
    company: '',
    photo: '/testimonials/jean-christian-heintz.jpg',
    quote:
      'Learning from a ship captain is different. Captain Mustapha brings the perspective of someone who has spent years at sea, offering practical insights that go beyond theory.',
  },
  {
    slug: 'oliver-woodard',
    name: 'Oliver Woodard',
    role: 'Sales Director LNG',
    company: 'Silverstream Technologies',
    photo: '/testimonials/oliver-woodard.jpg',
    quote:
      "Whether you're new to LNG or already experienced, there's something valuable for you. Captain Mustapha makes complex topics easy to understand while keeping them highly informative and relevant.",
  },
  {
    slug: 'aziz-bamik',
    name: 'Aziz Bamik',
    role: 'Chief Business Officer',
    company: 'Ascenz Marorka (GTT)',
    photo: '/testimonials/aziz-bamik.jpg',
    quote:
      "Whether it's LNG shipping or offshore terminal operations, Captain Mustapha is a wealth of knowledge. He's someone you can trust to guide you throughout your LNG journey.",
  },
  {
    slug: 'andrew-stafford',
    name: 'Andrew Stafford',
    role: 'Technical Director',
    company: 'Trelleborg Marine Systems',
    photo: '/testimonials/andrew-stafford.jpg',
    quote:
      "Captain Mustapha's experience as an LNG Master Mariner gives him an exceptional foundation. His operational expertise and broad industry knowledge make him a trusted guide for LNG professionals.",
  },
  {
    slug: 'terrance-roberts',
    name: 'Terrance Roberts',
    role: 'FLNG Global Business Development Manager',
    company: 'American Bureau of Shipping (ABS)',
    photo: '/testimonials/terrance-roberts.jpg',
    quote:
      'Captain Mustapha brings a perspective that few professionals can offer. His real-world LNG operational experience provides insights that are invaluable to those working across the industry.',
  },
  {
    slug: 'sergio-chapa',
    name: 'Sergio Chapa',
    role: 'LNG Industry Analyst',
    company: 'Poten & Partners',
    photo: '/testimonials/sergio-chapa.jpg',
    quote:
      "Captain Mustapha explains LNG in a way that's accessible for newcomers while still delivering new insights for experienced professionals. Even I continue to learn from him.",
  },
];

export const approachPillars = [
  {
    icon: 'layers',
    title: 'Technical Foundation',
    body: 'Build the technical foundation that supports confident decision-making throughout your LNG career.',
  },
  {
    icon: 'scales',
    title: 'Technical Judgment',
    body: 'Develop the ability to analyse situations, evaluate options, and make sound technical decisions with confidence.',
  },
  {
    icon: 'cycle',
    title: 'Operational Thinking',
    body: 'Go beyond procedures by understanding the reasoning behind LNG operations and how they connect in practice.',
  },
  {
    icon: 'network',
    title: 'Systems Perspective',
    body: 'See the bigger picture by connecting LNG systems, ship operations, and the wider value chain into one complete framework.',
  },
  {
    icon: 'shield',
    title: 'Safety Mindset',
    body: 'Develop the awareness and judgment needed to recognise risks and support safe, effective LNG operations.',
  },
  {
    icon: 'dollar',
    title: 'Commercial Awareness',
    body: 'Understand how technical operations influence the commercial realities of LNG shipping and the wider industry.',
  },
  {
    icon: 'badge',
    title: 'Professional Credibility',
    body: 'Communicate technical concepts with clarity, explain your reasoning with confidence, and earn professional trust.',
  },
  {
    icon: 'users',
    title: 'Expert Coaching',
    body: 'Accelerate your development through live coaching, practical discussions, and direct guidance in every session.',
  },
];

export const transformations = [
  {
    icon: 'gauge',
    title: 'Technical Confidence',
    lead: 'Apply LNG knowledge with confidence.',
    body: 'Make sound technical decisions and explain complex concepts with clarity.',
  },
  {
    icon: 'scales',
    title: 'Professional Judgment',
    lead: 'Think like an LNG professional.',
    body: 'Connect technical, operational, and commercial concepts with confidence.',
  },
  {
    icon: 'mic',
    title: 'Executive Communication',
    lead: 'Communicate with authority.',
    body: 'Speak confidently in interviews, meetings, and technical discussions.',
  },
  {
    icon: 'steps',
    title: 'Career Readiness',
    lead: 'Be ready for your next opportunity.',
    body: 'Approach interviews, promotions, and greater responsibility with confidence.',
  },
];

export const personas = [
  {
    name: 'Transitioning Officers',
    meta: 'Deck officers & engineers transitioning from LPG, oil, or chemical into LNG',
    body: 'They bring valuable seagoing experience but need the confidence and technical foundation to successfully transition into LNG. This program prepares them to perform with confidence from interview to onboarding.',
    stats: [
      { num: 'Foundation', cap: 'Build your LNG fundamentals' },
      { num: 'Confidence', cap: 'Interview-ready preparation' },
      { num: 'Transition', cap: 'Move into LNG with confidence' },
    ],
  },
  {
    name: 'LNG Officers & Engineers',
    meta: 'Already serving onboard LNG carriers and ready for the next level',
    body: 'They understand LNG operations and want to deepen their technical judgment, strengthen decision-making, and prepare for greater responsibility onboard.',
    stats: [
      { num: 'Technical Judgment', cap: 'Go beyond procedures' },
      { num: 'Leadership', cap: 'Lead technical discussions' },
      { num: 'Progression', cap: 'Prepare for promotion' },
    ],
  },
  {
    name: 'Shore-Based Professionals',
    meta: 'Traders, analysts, commercial teams, journalists, terminal & technical advisors',
    body: 'They need practical insight into LNG shipping without sailing. LNG Ready helps them connect operations, technology, and commerce with confidence.',
    stats: [
      { num: 'Operational Insight', cap: 'Understand LNG shipping' },
      { num: 'Commercial Context', cap: 'Connect operations and business' },
      { num: 'Professional Credibility', cap: 'Speak with confidence' },
    ],
  },
];

export const curriculum = [
  {
    icon: 'layers',
    title: 'Week 1 — LNG Foundations',
    body: 'Build the foundation every LNG professional needs. Explore the LNG value chain from natural gas extraction and liquefaction through transportation and regasification, before understanding how LNG carriers are designed and why every part of the vessel serves a specific purpose.',
  },
  {
    icon: 'gear',
    title: 'Week 2 — LNG Ship Systems',
    body: 'Discover the equipment and propulsion systems that keep LNG carriers operating safely and efficiently. From cargo handling equipment to modern dual-fuel engines, you’ll understand how these systems work together in real operations.',
  },
  {
    icon: 'tank',
    title: 'Week 3 — Cargo Containment Systems',
    body: 'Develop a clear understanding of the technologies that make LNG shipping possible. Compare Moss, membrane, and other containment systems while exploring their design, operational characteristics, and practical applications.',
  },
  {
    icon: 'cycle',
    title: 'Week 4 — Cargo Operations',
    body: 'Follow the complete operational lifecycle of an LNG carrier, from dry dock preparation and loading through the loaded voyage, discharging, and returning to dry dock. Learn how each stage connects to the next and the decisions that drive safe, efficient operations.',
  },
  {
    icon: 'gauge',
    title: 'Week 5 — Voyage & Fuel Management',
    body: 'Explore how LNG cargo is managed throughout the voyage, including boil-off gas, cargo pressure, and temperature control. You’ll also examine LNG as a marine fuel, fuel gas systems, and LNG bunkering as the industry continues to evolve.',
  },
  {
    icon: 'shield',
    title: 'Week 6 — Safety & Commercial Awareness',
    body: 'Finish by developing the broader perspective expected of today’s LNG professionals. Cover safety and emergency response before exploring chartering, maintenance, reporting, ship–shore communication, and the commercial realities that shape LNG shipping.',
  },
];

export const cohortFacts = [
  {
    icon: 'calendar',
    title: 'Starts 6 October 2026',
    body: 'Your six-week coaching journey begins with your first live coaching session.',
  },
  {
    icon: 'bookmark',
    title: 'Two Sessions Per Week',
    body: 'Live coaching takes place every Tuesday and Friday, with each session building naturally on the previous one.',
  },
  {
    icon: 'clock',
    title: '90 Minutes Each',
    body: 'Designed to go beyond the basics through coaching, discussion, practical examples, and live Q&A.',
  },
  {
    icon: 'phone',
    title: '1:00 PM UTC',
    body: 'Every session begins at 1:00 PM UTC, giving you one consistent schedule throughout the six-week program.',
  },
];

export const cohortTimeline = [
  { label: 'Cohort start', note: 'Opening session', when: '6 Oct 2026', time: '1:00 PM UTC' },
  {
    label: 'Six weeks live',
    note: '2 sessions / week · 90 min each',
    when: '12 sessions',
    time: '1:00 PM UTC',
  },
  {
    label: 'Live simulator demonstrations',
    note: 'Putting knowledge into practice',
    /* no date or time — the demonstrations follow relevant sessions rather
       than being a separate final event */
    when: 'After Sessions',
  },
];

export const pricing = {
  amount: 'Enrollment Closed',
  waitlistLead: 'LNG Ready is delivered through small, selective cohorts.',
  /* the supporting line below the beehiiv waitlist form */
  waitlistAction: 'Enter your email to be notified for the next cohorts.',
  features: [
    '**Six weeks of live coaching** — interactive sessions with real-time discussion, feedback, and Q&A.',
    '**Only 30 participants** — deliberately limited so the coaching remains personal and every participant receives direct support.',
    '**A guided cohort experience** — progress alongside ambitious LNG professionals with ongoing coaching and expert mentorship.',
    '**The complete LNG Ready Framework** — Foundation, Systems Map, and Commercial Context.',
    '**LNG Ship Cargo Simulator** — experience LNG cargo operations through a realistic simulated shipboard environment.',
    '**12 months of resource library access** — session recordings, supporting resources, and practical reference materials.',
    '**Recognition of completion** — together with the confidence, technical judgment, and professional capability you’ll carry forward.',
  ],
};

/* ---------------------------------------------------------------------------
   ICLOSED EMBED START
   iClosed's popup loader, used verbatim and mounted once for the whole page
   (see App.jsx). It binds itself to any element carrying data-iclosed-link and
   data-embed-type="popup", then renders and controls its own popup modal.
   The in-house training CTA supplies its own link via `inHouse.ctaLink`.
   --------------------------------------------------------------------------- */
export const iclosedLoader = `
<script type="text/javascript" src="https://app.iclosed.io/assets/widget.js" async></script>
`;
/* ICLOSED EMBED END */

/* ---------------------------------------------------------------------------
   BEEHIIV EMBED START
   beehiiv's waitlist subscribe form, used verbatim. The form is set to render
   inline in beehiiv's own builder, so it appears wherever this script is
   mounted (see Pricing.jsx). Its fields, button label and colours are styled
   in that builder rather than in this repo:
   app.beehiiv.com/subscribe_form_builder/4fe4a635-39b5-4036-ba0f-ea61bb76cca0
   --------------------------------------------------------------------------- */
export const waitlistForm = `
<script async src="https://subscribe-forms.beehiiv.com/v3/loader.js" data-beehiiv-form="4fe4a635-39b5-4036-ba0f-ea61bb76cca0"></script>
`;
/* BEEHIIV EMBED END */

/** `a` is an array of paragraphs — a single-item array is a one-paragraph answer. */
export const faqs = [
  {
    q: 'Who is LNG Ready for?',
    a: [
      'LNG Ready is designed for ambitious professionals across the LNG industry, including transitioning officers, experienced LNG officers and engineers, and shore-based professionals such as traders, analysts, terminal personnel, technical advisors, consultants, managers, and business leaders. Whether you’re preparing to enter LNG or deepen your expertise, the program provides a practical framework for professional growth.',
    ],
    defaultOpen: true,
  },
  {
    q: 'Does LNG Ready cover the entire LNG value chain?',
    a: [
      'LNG Ready provides an introduction to the complete LNG value chain, including natural gas production, processing, liquefaction, transportation, regasification, and end use, so you understand how each stage connects.',
      'However, the program’s primary focus is LNG shipping. The coaching is centred on LNG carriers, cargo operations, vessel systems and the technical and operational knowledge needed to perform with confidence in the LNG maritime industry.',
    ],
  },
  {
    q: 'Is this suitable if I’m new to LNG?',
    a: [
      'Yes. LNG Ready is designed for professionals entering the LNG industry as well as those already working within it. No previous LNG experience is required. The program builds a strong technical foundation and the confidence to apply it in real-world LNG operations.',
    ],
  },
  {
    q: 'I already work on LNG carriers. Is this still for me?',
    a: [
      'Yes. LNG Ready is designed not only for professionals entering the LNG industry, but also for experienced LNG officers and engineers who want to deepen their technical judgment, strengthen their decision-making, and prepare for greater responsibility, promotions, and technical leadership.',
    ],
  },
  {
    q: 'Can I ask questions during the live sessions?',
    a: [
      'Yes. Every session is delivered live and includes discussion, coaching, and real-time Q&A. You’ll have the opportunity to ask questions, explore real operational scenarios, and receive direct guidance throughout the program.',
    ],
  },
  {
    q: 'How much time should I expect to commit each week?',
    a: [
      'LNG Ready is designed to fit alongside a full-time professional schedule. Live sessions take place over six weeks, with additional time for reflection, reviewing resources, and applying what you’ve learned between sessions.',
    ],
  },
  {
    q: 'Are the sessions recorded?',
    a: [
      'Yes. Every live session is recorded, and you’ll receive 12 months of access to session recordings and supporting resources so you can revisit key discussions whenever you need them.',
    ],
  },
  {
    q: 'How many participants are in each cohort?',
    a: [
      'Each cohort is limited to 30 participants. Keeping the group intentionally small allows for meaningful interaction, direct coaching, and individual attention throughout the program.',
    ],
  },
  {
    q: 'What happens after I enrol?',
    a: [
      'Once your place is confirmed, you’ll receive your onboarding information, program schedule, and access details before the cohort begins. We’ll guide you through everything you need to be ready for your first live session.',
    ],
  },
  {
    q: 'Is there a guarantee?',
    a: [
      'Yes. Every enrolment is backed by the **LNG School Promise**.',
      'Complete the full six-week program and actively participate in the live coaching sessions. If, after the six weeks, you don’t believe LNG Ready has delivered real value, Captain Mustapha will personally continue coaching you for an additional two weeks at no extra cost.',
      'If you still feel the program hasn’t met your expectations, simply email us within 15 days of completing the program with your reason for requesting a refund, and we’ll refund your full investment.',
    ],
  },
];

export const guarantee = [
  'We stand behind the quality of **LNG Ready** and our commitment to your success.',
  "If you actively participate by attending the live sessions and completing the program, yet feel it has not provided meaningful value, we'll continue coaching you **for an additional two weeks at no extra cost**.",
  "If, after that, you still believe LNG Ready has not met your expectations, simply email us within 15 days of completing the program and include the reason for your request, we'll provide a **100% refund**.",
  'Your commitment deserves ours, and we stand behind our promise.',
];

/**
 * Corporate / in-house training block, below the LNG Ready enrolment section.
 * Its CTA opens iClosed's popup via `ctaLink` (see components/InHouseTraining.jsx).
 */
export const inHouse = {
  eyebrow: 'In-House LNG Training',
  title: 'Train your team.',
  titleAlt: 'Your way.',
  cards: [
    {
      icon: 'sliders',
      title: 'Customized',
      body: 'Built around your team’s experience, roles, and specific training requirements.',
    },
    {
      icon: 'users',
      title: 'Small groups',
      body: 'Focused training for your team, with direct interaction, practical discussion, and coaching.',
    },
    {
      icon: 'globe',
      title: 'Anywhere',
      body: 'Delivered at your premises, at your preferred location worldwide, or online.',
    },
  ],
  note: 'From LNG fundamentals to cargo operations, bunkering, safety, and other technical topics — training is tailored to your team’s needs.',
  cta: 'DISCUSS YOUR COMPANY TRAINING NEEDS',
  /* iClosed reads this off the CTA element to open its own popup modal */
  ctaLink: 'https://app.iclosed.io/e/LNGSchool/in-house-lng-training',
};

